'use client';

import { cx } from 'cva';
import { isEmpty, trim } from 'lodash-es';
import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import ReactPlayer from 'react-player';

function VideoPlayer(props) {
  const { children = null, src = '', playIconSize = 80, ...rest } = props;
  const [videoLoadFailed, setVideoLoadFailed] = useState(false);
  const [thumbnail, setThumbnail] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handleVideoClick = () => {
    setIsPlaying(!isPlaying);
  };

  const handleVideoLoadError = () => {
    setVideoLoadFailed(true);
  };

  const handleVideoLoadSuccess = () => {
    setVideoLoadFailed(false);
  };

  const createThumbnail = (videoLink) => {
    let baseVideoUrl = videoLink.substring(0, videoLink.lastIndexOf('.'));
    let newExtension = 'jpg';
    let newVideoLink = baseVideoUrl + '.' + newExtension;
    setThumbnail(newVideoLink);
  };

  const isPublicUrl = (videoUrl) => {
    return (
      !videoUrl.includes('cloudinary') &&
      !videoUrl.includes(process.env.NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME)
    );
  };

  useEffect(() => {
    if (!videoLoadFailed && isEmpty(trim(src))) {
      setVideoLoadFailed(true);
    }

    if (src && src.length) {
      if (!isPublicUrl(src)) {
        createThumbnail(src);
      } else {
        setThumbnail(false);
      }
      // setVideoLoadFailed(false);
    }
  }, [src, videoLoadFailed]);

  return (
    <div role="button" onClick={handleVideoClick} className="h-full w-full">
      <div
        className={cx(
          'flex h-full w-full items-center justify-center',
          !videoLoadFailed && 'hidden',
        )}>
        {children}
      </div>

      <ReactPlayer
        style={{ display: videoLoadFailed ? 'none' : '' }}
        controls
        url={src}
        light={thumbnail} // thumbnail url
        onError={handleVideoLoadError}
        onReady={handleVideoLoadSuccess}
        playing={isPlaying}
        height="100%"
        width="100%"
        playIcon={
          <Image
            src="/assets/icons/video-play-icon.svg"
            alt={thumbnail}
            className="text-primary"
            height={playIconSize}
            width={playIconSize}
          />
        }
        {...rest}
      />
    </div>
  );
}

export default VideoPlayer;
